var  rxId = /^\w{3,11}$/
var  rxPwd = /^(?=.{6,25})(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/

module.exports = {
    validateId:function(id) {
        return rxId.test(id);
    },

    validatePwd:function(pwd) {
        return rxPwd.test(pwd);
    }
}